// src/pages/PublicPage.js
import React from 'react';
import AsanaTasks from '../AsanaTasks';

function PublicPage() {
  return (
    <div>
      <h1>Project Board</h1>
      <AsanaTasks />
    </div>
  );
}

export default PublicPage;

